import { useEffect, useMemo, useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
// import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import InputBar from '../InputBar';
import useOnboardingStore from 'stores/onboardingStore';
import BPSelect from 'components/BionicUI/select/BPSelect';
import { Country, getData } from 'country-list';
// import {
//   GetAppConfigByKeyRequest,
//   RestrictedCountry,
// } from 'core/models/app-config/get-app-config-by-key.model';
// import { AppConfigV1BaseServerRepo } from 'core/repository/base-server/v1/app-config.repo';
// import { AppConfigurationKey } from 'core/models/app-config/get-app-config.model';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPButton from 'components/BionicUI/button/BPButton';
import { PutUserAddressRequest } from 'core/models/users/address/put-user-address.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import BPToast from 'components/BionicUI/toast/BPToast';
// import useNotifyStore from 'stores/notifyStore';
// import { restrictedCountries } from 'components/geo-block/countryList';

const ChooseCountry = () => {
  // const { setCurrentToast } = useNotifyStore();
  // const [restrictedCountries, setRestrictedCountries] = useState<
  //   RestrictedCountry[]
  // >([]);
  // const [isRestrictedCountry, setIsRestrictedCountry] =
  //   useState<boolean>(false);
  const [selectedCountryName, setSelectedCountryName] = useState<string | null>(
    null
  );
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep } = useOnboardingStore();
  const countries = getData();
  const sortedCountries = useMemo(() => {
    return countries.sort((a, b) => a.name.localeCompare(b.name));
  }, [countries]);

  // const fetchData = async () => {
  //   try {
  //     const request: GetAppConfigByKeyRequest = {
  //       key: AppConfigurationKey.RESTRICTED_COUNTRIES,
  //     };
  //     const response = await new AppConfigV1BaseServerRepo().getByKey(request);
  //     setRestrictedCountries(
  //       response[AppConfigurationKey.RESTRICTED_COUNTRIES]
  //     );
  //   } catch (err: any) {
  //     const errMsg = err.response?.data?.message || 'Try again later.';
  //     setCurrentToast(
  //       <BPToast message="Failed" description={errMsg} variant="error" />
  //     );
  //   }
  // };

  useEffect(() => {
    // fetchData();
    setTimeout(() => setShowInputBar(true), 1000);
  }, []);

  const handleCountryChange = (code: string) => {
    // setIsRestrictedCountry(
    //   restrictedCountries.map((c) => c.code).includes(code)
    // );
    setSelectedCountryName(
      sortedCountries.find((country: Country) => country.code === code)?.name ??
        null
    );
  };

  async function handleSubmit() {
    const request: PutUserAddressRequest = {
      country: selectedCountryName ?? '',
    };

    try {
      await new UserV1BaseServerRepo().updateAddress(request);
      nextStep();
      // setProgressStep(8)
    } catch (error) {
      console.error({ error });
    }
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: "What's your nationality?",
            sound: 'step1/whats-your-nationality.mp3',
          }}
          line2={{
            text: 'Please enter the country where you hold citizenship...',
            sound: 'step1/please-enter-the-country.mp3',
          }}
        >
          {/* <div className="grid gap-2">
            <div className="text-bionic-muted text-[14px]">
              We are unable to accept applications from certain restricted
              countries, including the USA (this includes US citizens residing
              in another country). We will carry out KYC checks to confirm
              member residency during onboarding.
            </div>
            <div>
              <BPLinkButton>Find out more information</BPLinkButton>
            </div>
          </div> */}
        </BPInstruction>
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(2)}>
          <div className="grid relative grid-rows-[auto_1fr] sm:grid-cols-[auto_1fr] gap-4 items-center">
            <BPSelect
              state={
                // isRestrictedCountry
                // ? 'error' :
                selectedCountryName === null ? 'default' : 'success'
              }
              placeholder="Select country"
              options={countries.map((country) => {
                return {
                  value: country.code,
                  label: country.name,
                };
              })}
              onValueChange={(value) => handleCountryChange(value)}
              useContainerEdge
            />
            <BPContainer twWidth="w-auto flex">
              <BPButton
                state="primary"
                onClick={handleSubmit}
                disabled={selectedCountryName === null}
                // disabled={isRestrictedCountry || selectedCountryName === null}
              >
                Submit
              </BPButton>
            </BPContainer>
          </div>
          {/* {isRestrictedCountry && (
            <div className="text-bionic-error text-[12px] text-center px-[50px]">
              We are unable to continue with your application as you reside in a
              restricted country, please contact{' '}
              <a href="mailto:help@bionic.io">help@bionic.io</a> if you want to
              appeal this decision
            </div>
          )} */}
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default ChooseCountry;
